import { sectionsApi } from 'entities/section/api/sectionsApi';
import { LoadableInterface } from 'shared/types/loadableInterface';
import filter from 'lodash-es/filter';
import find from 'lodash-es/find';
import map from 'lodash-es/map';
import { makeAutoObservable, runInAction } from 'mobx';
import { SectionModel } from 'entities/section/model/sectionModel';
import { RootStore } from 'app/store/rootStore';

export class SectionStore implements LoadableInterface {
  private _rootStore: RootStore;
  public sections: SectionModel[] | null = null;

  public isPending = false;
  public isError = false;

  constructor({ rootStore }: { rootStore: RootStore }) {
    this._rootStore = rootStore;
    makeAutoObservable(this);
  }

  public findSectionById(id: string) {
    return find(this.sections, (s) => s.id === id);
  }

  public async fetchBulk() {
    this._rootStore.stateStore.isSectionsLoading = true;

    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    try {
      const sections = await sectionsApi.fetchBulk();

      runInAction(() => {
        this.sections = map(sections, (section) => new SectionModel(section));
        this.isPending = false;
        this._rootStore.stateStore.isSectionsLoading = false;
      });
    } catch (e) {
      runInAction(() => {
        this._rootStore.stateStore.isSectionsLoading = false;
        this.isPending = false;
        this.isError = true;
      });
      console.error(e);
    }
  }

  public async localAddSection(sectionModel: SectionModel) {
    this.sections = [...(this.sections || []), sectionModel];
  }

  public async localDeleteSections(ids: string[]) {
    if (this.sections) {
      this.sections = filter(
        this.sections,
        (section) => !ids.includes(section.id)
      );
    }
  }
}
